import { setup } from 'xstate5'

export const PmSettingsRequestPureState = setup({
  types: {
    events: { type: 'my-type' },

    meta: {} as {
      error?: boolean
      errorMessage?: string
    },
  },
}).createMachine({
  id: 'PmSettingsRequestPureState',
  initial: 'default',

  states: {
    default: {},

    save: {
      initial: 'saving',

      states: {
        saving: {},

        error: {
          meta: {
            error: true,
            errorMessage: 'Unbekannter Fehler',
          },
        },

        success: {
          type: 'final',
        },
      },
    },
  },
})
